import {
    AfterViewInit,
    Component,
    Inject,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MyTasksService } from 'dm-src/app/modules/my-tasks/my-tasks.service';
import {
    ColorClass,
    AUTH_SERVICE_IMPL,
    IAuthenticationService,
    ISupplierWorktimeControlService,
    SUPPLIER_WORKTIME_CONTROL_SERVICE_IMPL,
    SupplierWorktimeControl,
    IMAGE_COMPRESSION_SERVICE_IMPL,
    IImageCompressionService,
    ComletedStartControl,
    FlashMessageService,
    MultiPickingTask,
    TaskList,
    DeliveryTaskState,
    WorktimeTaskBlock,
} from 'shared';
import { TaskFailedModalService } from 'dm-src/app/modules/shared/task-failed-modal/task-failed-modal.service';
import { ModalService } from 'shared';
import { NavigationEnd, Router } from '@angular/router';
import { IsWrappingService } from 'dm-src/services/is-wrapping/is-wrapping.service';
import { NativeBarcodeReaderService } from 'dm-src/services/native-barcode-reader/native-barcode-reader.service';
import { SumupService } from 'dm-src/services/sumup/sumup.service';
import { NativeTakePhotoService } from 'dm-src/services/native-take-photo/native-take-photo.service';
import { IosAndAndroidNatvieFunctionsService } from 'dm-src/services/ios-and-android-natvie-functions/ios-and-android-natvie-functions.service';
import { TranslateService } from '@ngx-translate/core';
import { UserRole } from '../../../../../shared/src/lib/types/user-role';
import { Subscription } from 'rxjs';
import { ServiceBaseService } from 'projects/shared/src/lib/services/service-base.service';
import { TaskGroup } from 'dm-src/types/task-group';
import { TaskGroupItem } from 'dm-src/types/task-group-item';
import { TaskGroupItemType } from 'dm-src/types/task-group-item-type';

interface WorktimeTaskBlockView {
    worktime: WorktimeTaskBlock;
    allTasks: TaskGroupItem[];
    taskGroup: TaskGroup;
    totalTaskCount: number;
    collectingTaskCount: number;
    deliveringTaskCount: number;
    hideDone: boolean;
    hasDoneTasks: boolean;
    isCollapsed: boolean;
}

@Component({
    selector: 'app-my-tasks',
    templateUrl: './my-tasks.component.html',
    styleUrls: ['./my-tasks.component.scss'],
})
export class MyTasksComponent implements OnInit, AfterViewInit, OnDestroy {
    private readonly _logisticsMapBaseUrl = 'https://logsticstest.justfun4.me/';
    private readonly _defaultLogisticsEnvironmentName = 'staging_hu';

    public ColorClass = ColorClass;
    public isNativeApplicationWrapper: boolean;
    public isNativeAppTrackingStarted = false;
    public notCompletedStartControl: SupplierWorktimeControl;
    public comletedStartControl: ComletedStartControl = new ComletedStartControl();

    public imgResultAfterCompression: string;
    public photoLoaded: boolean;
    public controlPhotoImageContent: string;
    public controlPhotoImageExtension: string;
    public additionalInfo: string;
    public isWrapping = false;
    public isControlSaveBlocked = false;
    public isLoading = false;
    public isNewWrapper = !!window.ReactNativeWebView;

    public maximumMultipickingTasks: number;
    public multiPickingSelectedTasks: MultiPickingTask[];
    public multiPickingAlreadyInProgress = false;
    public taskList: TaskList;
    public unplannedTaskGroup: TaskGroup | null = null;
    public unplannedHasDoneTasks = false;
    public unplannedHideDone = false;
    public unplannedIsCollapsed = false;
    public unplannedTotalTaskCount = 0;
    public unplannedCollectingTaskCount = 0;
    public unplannedDeliveringTaskCount = 0;
    public unplannedRefundingTaskCount = 0;
    public worktimeTaskBlocks: WorktimeTaskBlockView[] = [];
    public nonTodayTaskGroups: TaskGroup[] = [];
    public logisticsMapUrl: SafeResourceUrl | null = null;
    private allTaskGroups: TaskGroup[] = [];
    private hiddenDoneWorktimeIDs = new Set<string>();
    private expandedGroupKey: string | null = null;
    private isGroupAccordionInitialized = false;
    private routerSubscription: Subscription;
    private taskListSubscription: Subscription;
    private taskGroupsSubscription: Subscription;

    public get showFindNextTaskButton(): boolean {
        if (this.taskList?.useDynamicRouting) {
            return true;
        }

        return !this.allTaskGroups.some((group) =>
            (group.tasks || []).some((task) => !this.isDone(task))
        );
    }

    @ViewChild('logisticsMapModal', { static: true })
    private _logisticsMapModal: TemplateRef<unknown>;

    constructor(
        @Inject(AUTH_SERVICE_IMPL)
        private _authService: IAuthenticationService,
        public myTasksService: MyTasksService,
        public modalService: ModalService,
        private _taskFailedModalService: TaskFailedModalService,
        private isWrappingService: IsWrappingService,
        private nativeBarcodeReaderService: NativeBarcodeReaderService,
        private _sumUpService: SumupService,
        @Inject(SUPPLIER_WORKTIME_CONTROL_SERVICE_IMPL)
        private _supplierWorktimeControlService: ISupplierWorktimeControlService,
        private _router: Router,
        private _nativeTakePhotoService: NativeTakePhotoService,
        private _isWrappingService: IsWrappingService,
        private _iosAndAndroidNatvieFunctionsService: IosAndAndroidNatvieFunctionsService,
        @Inject(IMAGE_COMPRESSION_SERVICE_IMPL)
        private _imageCompressionService: IImageCompressionService,
        private _flashMessageService: FlashMessageService,
        private _translateService: TranslateService,
        private _ngbModalService: NgbModal,
        private _sanitizer: DomSanitizer
    ) {}

    ngAfterViewInit(): void {
        this.isWrapping = this._isWrappingService.isWrapping();
        if (window.ReactNativeWebView) {
            this._iosAndAndroidNatvieFunctionsService
                .getCurrentPostMessage()
                .subscribe((response) => {
                    if (response.functionName === 'CAMERA_START') {
                        this.setControlPhotoImageContent(
                            'data:image/jpeg;base64,' + response?.result,
                            'jpeg'
                        );
                        this.imgResultAfterCompression =
                            'data:image/jpeg;base64,' + response?.result;
                        this._iosAndAndroidNatvieFunctionsService.getAppVersion();
                    } else if (response.functionName === 'GET_LAT_LON') {
                        this._iosAndAndroidNatvieFunctionsService.currentLatLonData.next(
                            response?.result
                        );
                    }
                });
        } else if (this.isWrapping) {
            this.nativeBarcodeReaderService.initBarcodeReading(false);
            this._sumUpService.init();

            setTimeout(() => {
                this._nativeTakePhotoService.init();
            }, 0);

            this._nativeTakePhotoService.getBase64ContentResult().subscribe((result) => {
                if (result) {
                    this.imgResultAfterCompression = result;
                    this.photoLoaded = true;
                }
            });
        }
    }

    ngOnInit() {
        this.isLoading = true;
        this.myTasksService.getMyTasks();

        this.taskListSubscription = this.myTasksService.taskList.subscribe((taskList) => {
            this.taskList = taskList;
            this.rebuildTaskSections();
        });

        this.taskGroupsSubscription = this.myTasksService.taskGroups.subscribe(
            (taskGroups) => {
                this.allTaskGroups = taskGroups;
                this.rebuildTaskSections();
            }
        );

        this.myTasksService.multiPickingAlreadyInProgress.subscribe(
            (multiPickingAlreadyInProgress) => {
                this.multiPickingAlreadyInProgress = multiPickingAlreadyInProgress;
            }
        );

        this.myTasksService.selectedMultipickingTasks.subscribe((selectedTasks) => {
            this.multiPickingSelectedTasks = selectedTasks;
        });

        this.routerSubscription = this._router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                if (event.url == '/my-tasks') {
                    if (
                        this.isWrappingService.isWrapping() ||
                        window.ReactNativeWebView
                    ) {
                        this.myTasksService.startAppGPSTracking();
                    }
                }

                if (event.url == '/logout') {
                    this.resetAll();
                    this.myTasksService.stopAppGPSTracking();
                }
            }
        });

        this.myTasksService.maximumMultipickingTasks.subscribe((value) => {
            this.maximumMultipickingTasks = value;
        });

        this.myTasksService.isNativeApplicationWrapper.subscribe((value) => {
            this.isNativeApplicationWrapper = value;
        });
        this.myTasksService.isNativeAppTrackingStarted.subscribe((value) => {
            this.isNativeAppTrackingStarted = value;
            this.isLoading = false;
        });
    }

    ngOnDestroy() {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
        if (this.taskListSubscription) {
            this.taskListSubscription.unsubscribe();
        }
        if (this.taskGroupsSubscription) {
            this.taskGroupsSubscription.unsubscribe();
        }
    }

    refreshSite() {
        window.location.reload();
    }

    public refreshTasks(): void {
        this.myTasksService.getMyTasks(true);
    }

    public openLogisticsMap(supplierRegionID: string): void {
        this.logisticsMapUrl = this.buildLogisticsMapUrl(supplierRegionID);

        if (!this.logisticsMapUrl) {
            return;
        }

        this._ngbModalService.open(this._logisticsMapModal, {
            windowClass: 'modal-holder modal-fullscreen logistics-map-modal-window',
            size: 'xl',
        });
    }

    public toggleCompletedTasks(worktimeID: string): void {
        if (this.hiddenDoneWorktimeIDs.has(worktimeID)) {
            this.hiddenDoneWorktimeIDs.delete(worktimeID);
        } else {
            this.hiddenDoneWorktimeIDs.add(worktimeID);
        }

        const worktimeBlock = this.worktimeTaskBlocks.find(
            (block) => block.worktime.id === worktimeID
        );

        if (worktimeBlock) {
            worktimeBlock.hideDone = this.hiddenDoneWorktimeIDs.has(worktimeID);
        }
    }

    public toggleUnplannedCompletedTasks(): void {
        this.unplannedHideDone = !this.unplannedHideDone;
    }

    public toggleUnplannedGroup(): void {
        this.toggleExclusiveGroup(this.getUnplannedGroupKey());
    }

    public toggleWorktimeBlock(worktimeID: string): void {
        this.toggleExclusiveGroup(this.getWorktimeGroupKey(worktimeID));
    }

    public toggleNonTodayGroup(taskGroup: TaskGroup): void {
        this.toggleExclusiveGroup(this.getNonTodayGroupKey(taskGroup));
    }

    public isNonTodayGroupCollapsed(taskGroup: TaskGroup): boolean {
        return this.expandedGroupKey !== this.getNonTodayGroupKey(taskGroup);
    }

    private buildLogisticsMapUrl(supplierRegionID: string): SafeResourceUrl | null {
        if (!supplierRegionID || !this.taskList?.supplierID) {
            return null;
        }

        const logisticsMapUrl = new URL(this._logisticsMapBaseUrl);
        logisticsMapUrl.searchParams.set(
            'ENVIRONMENT_NAME',
            this.getLogisticsEnvironmentName()
        );
        logisticsMapUrl.searchParams.set('regionGuid', supplierRegionID);
        logisticsMapUrl.searchParams.set('supplierGuid', this.taskList.supplierID);

        return this._sanitizer.bypassSecurityTrustResourceUrl(logisticsMapUrl.toString());
    }

    private rebuildTaskSections(): void {
        if (!this.taskList) {
            return;
        }

        const allTasks = this.allTaskGroups.reduce(
            (tasks, group) => tasks.concat(group.tasks || []),
            [] as TaskGroupItem[]
        );
        const today = this.getDay(this.taskList.today || new Date());
        const todayTasks = allTasks.filter(
            (item) => this.getTaskDay(item).getTime() === today.getTime()
        );
        const todayUnplannedTasks = todayTasks.filter(
            (item) =>
                item.taskType === TaskGroupItemType.CollectingTask ||
                item.taskType === TaskGroupItemType.DeliveringTask ||
                item.taskType === TaskGroupItemType.RefundingTask
        );
        if (!this.taskList.useDynamicRouting) {
            this.setUnplannedTaskGroup(today, todayUnplannedTasks);
            this.worktimeTaskBlocks = [];
            this.nonTodayTaskGroups = this.buildNonTodayTaskGroups(today);
            this.synchronizeGroupAccordion();
            return;
        }

        const unplannedCollectingOrderIDs = new Set(
            this.taskList.unplannedCollectingOrderIDs || []
        );
        const unplannedDeliveringOrderIDs = new Set(
            this.taskList.unplannedDeliveringOrderIDs || []
        );
        const unplannedTasks = todayTasks.filter(
            (item) =>
                item.taskType === TaskGroupItemType.RefundingTask ||
                (item.taskType === TaskGroupItemType.CollectingTask &&
                    unplannedCollectingOrderIDs.has(item.task.orderID)) ||
                (item.taskType === TaskGroupItemType.DeliveringTask &&
                    unplannedDeliveringOrderIDs.has(item.task.orderID))
        );

        this.setUnplannedTaskGroup(today, unplannedTasks);

        this.worktimeTaskBlocks = (this.taskList.worktimeBlocks || []).map((worktime) => {
            const collectingOrderIDs = new Set(worktime.collectingOrderIDs || []);
            const deliveringOrderIDs = new Set(worktime.deliveringOrderIDs || []);
            const worktimeTasks = this.sortTaskItems(
                todayTasks.filter(
                    (item) =>
                        (item.taskType === TaskGroupItemType.CollectingTask &&
                            collectingOrderIDs.has(item.task.orderID)) ||
                        (item.taskType === TaskGroupItemType.DeliveringTask &&
                            deliveringOrderIDs.has(item.task.orderID))
                )
            );
            const hideDone = this.hiddenDoneWorktimeIDs.has(worktime.id);

            return {
                worktime,
                allTasks: worktimeTasks,
                taskGroup: this.createTaskGroup(today, worktimeTasks),
                totalTaskCount: worktimeTasks.length,
                collectingTaskCount: this.getNotDoneTaskCount(
                    worktimeTasks,
                    TaskGroupItemType.CollectingTask
                ),
                deliveringTaskCount: this.getNotDoneTaskCount(
                    worktimeTasks,
                    TaskGroupItemType.DeliveringTask
                ),
                hideDone,
                hasDoneTasks: worktimeTasks.some((item) => this.isDone(item)),
                isCollapsed: true,
            };
        });

        this.nonTodayTaskGroups = this.buildNonTodayTaskGroups(today);
        this.synchronizeGroupAccordion();
    }

    private toggleExclusiveGroup(groupKey: string): void {
        this.expandedGroupKey = this.expandedGroupKey === groupKey ? null : groupKey;
        this.isGroupAccordionInitialized = true;
        this.applyGroupAccordionState();
    }

    private synchronizeGroupAccordion(): void {
        const availableGroupKeys = this.getAvailableGroupKeys();

        if (
            this.expandedGroupKey &&
            !availableGroupKeys.includes(this.expandedGroupKey)
        ) {
            this.expandedGroupKey = null;
        }

        if (!this.isGroupAccordionInitialized && availableGroupKeys.length) {
            const activeWorktimeBlock = this.worktimeTaskBlocks.find(
                (block) => block.worktime.isActive
            );

            if (this.unplannedTaskGroup) {
                this.expandedGroupKey = this.getUnplannedGroupKey();
            } else if (activeWorktimeBlock) {
                this.expandedGroupKey = this.getWorktimeGroupKey(
                    activeWorktimeBlock.worktime.id
                );
            } else {
                this.expandedGroupKey = availableGroupKeys[0];
            }
            this.isGroupAccordionInitialized = true;
        }

        this.applyGroupAccordionState();
    }

    private applyGroupAccordionState(): void {
        this.unplannedIsCollapsed = this.expandedGroupKey !== this.getUnplannedGroupKey();
        this.worktimeTaskBlocks.forEach((block) => {
            block.isCollapsed =
                this.expandedGroupKey !== this.getWorktimeGroupKey(block.worktime.id);
        });
    }

    private getAvailableGroupKeys(): string[] {
        const groupKeys: string[] = [];

        if (this.unplannedTaskGroup) {
            groupKeys.push(this.getUnplannedGroupKey());
        }

        groupKeys.push(
            ...this.worktimeTaskBlocks.map((block) =>
                this.getWorktimeGroupKey(block.worktime.id)
            ),
            ...this.nonTodayTaskGroups.map((group) => this.getNonTodayGroupKey(group))
        );

        return groupKeys;
    }

    private getUnplannedGroupKey(): string {
        return 'unplanned';
    }

    private getWorktimeGroupKey(worktimeID: string): string {
        return `worktime:${worktimeID}`;
    }

    private getNonTodayGroupKey(taskGroup: TaskGroup): string {
        return `non-today:${this.getDay(taskGroup.deliveryDate).getTime()}`;
    }

    private setUnplannedTaskGroup(today: Date, tasks: TaskGroupItem[]): void {
        const sortedTasks = this.sortTaskItems(tasks);
        this.unplannedTotalTaskCount = sortedTasks.length;
        this.unplannedCollectingTaskCount = this.getNotDoneTaskCount(
            sortedTasks,
            TaskGroupItemType.CollectingTask
        );
        this.unplannedDeliveringTaskCount = this.getNotDoneTaskCount(
            sortedTasks,
            TaskGroupItemType.DeliveringTask
        );
        this.unplannedRefundingTaskCount = this.getNotDoneTaskCount(
            sortedTasks,
            TaskGroupItemType.RefundingTask
        );
        this.unplannedHasDoneTasks = sortedTasks.some((item) => this.isDone(item));

        this.unplannedTaskGroup = sortedTasks.length
            ? this.createTaskGroup(today, sortedTasks)
            : null;
    }

    private buildNonTodayTaskGroups(today: Date): TaskGroup[] {
        return this.allTaskGroups
            .filter(
                (group) => this.getDay(group.deliveryDate).getTime() !== today.getTime()
            )
            .sort(
                (firstGroup, secondGroup) =>
                    this.getDay(secondGroup.deliveryDate).getTime() -
                    this.getDay(firstGroup.deliveryDate).getTime()
            )
            .map((group) =>
                this.createTaskGroup(
                    this.getDay(group.deliveryDate),
                    this.sortTaskItems(
                        (group.tasks || []).filter((item) => !this.isDone(item))
                    )
                )
            )
            .filter((group) => group.tasks.length > 0);
    }

    private createTaskGroup(date: Date, tasks: TaskGroupItem[]): TaskGroup {
        const group = new TaskGroup();
        group.deliveryDate = date;
        group.tasks = tasks;
        return group;
    }

    private sortTaskItems(tasks: TaskGroupItem[]): TaskGroupItem[] {
        return [...tasks].sort(
            (current, next) =>
                new Date(current.task.estimatedStartDate).getTime() -
                new Date(next.task.estimatedStartDate).getTime()
        );
    }

    private isDone(item: TaskGroupItem): boolean {
        return item.task.state === DeliveryTaskState[DeliveryTaskState.Done];
    }

    private getNotDoneTaskCount(
        tasks: TaskGroupItem[],
        taskType: TaskGroupItemType
    ): number {
        return tasks.filter((item) => item.taskType === taskType && !this.isDone(item))
            .length;
    }

    private getDay(date: Date): Date {
        const value = new Date(date);
        return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }

    private getTaskDay(item: TaskGroupItem): Date {
        const taskDate =
            item.taskType === TaskGroupItemType.RefundingTask &&
            item.task.deliveryDeadline
                ? item.task.deliveryDeadline
                : item.task.estimatedStartDate;

        return this.getDay(taskDate);
    }

    private getLogisticsEnvironmentName(): string {
        const environmentName = ServiceBaseService.getEnvironment;

        if (!environmentName || environmentName === 'dev') {
            return this._defaultLogisticsEnvironmentName;
        }

        return environmentName;
    }

    public onTaskFailSet(status: number) {
        if (status === 200) {
            this.myTasksService.removeTask(this._taskFailedModalService.taskID);
        }
    }

    public get isCalculatedPriceVisible(): boolean {
        return (
            this.multiPickingSelectedTasks &&
            0 < this.multiPickingSelectedTasks?.length &&
            this.multiPickingSelectedTasks?.some((x) => x.calculatedPriceEnabled)
        );
    }

    public showCalculatedPriceInfoModal() {
        this.modalService.setModalVisibility(true, 'calculated-price-info-modal');
    }

    public get calculatedPrice(): number {
        let sum = 0.0;

        if (this.isCalculatedPriceVisible) {
            sum = this.multiPickingSelectedTasks
                .filter((x) => x.calculatedPriceEnabled)
                .reduce((accumulator, currentValue) => {
                    return accumulator + currentValue.calculatedPrice;
                }, 0.0);
        }

        return sum;
    }

    public confirmWorkTimeStart() {
        const currentUser = this._authService.currentUser;

        if (currentUser.hasRoles([UserRole.Refunder])) {
            this.myTasksService.startAppGPSTracking();
        } else {
            this._supplierWorktimeControlService
                .GetStartControls(currentUser.userID)
                .subscribe((worktimeStartControls) => {
                    if (worktimeStartControls && worktimeStartControls.length > 0) {
                        this.notCompletedStartControl = worktimeStartControls[0];
                        this.modalService.setModalVisibility(
                            true,
                            'start-worktime-control'
                        );
                    } else {
                        this.modalService.setModalVisibility(
                            false,
                            'start-worktime-control'
                        );
                        this.modalService.setModalVisibility(
                            true,
                            'start-worktime-confirm'
                        );
                    }
                });
        }
    }

    public addComletedStartControl() {
        this.isControlSaveBlocked = true;
        this.comletedStartControl.supplierID = this._authService.currentUser?.userID;
        this.comletedStartControl.additionalInfo = this.additionalInfo;
        this.comletedStartControl.photoUrl = this.imgResultAfterCompression;
        this.comletedStartControl.supplierWorktimeControlID =
            this.notCompletedStartControl.supplierWorktimeControlID;

        if (this.IsControlsInvalid()) {
            this._flashMessageService.showMessage(
                this._translateService.instant('common.danger'),
                this._translateService.instant('common.some-validation-is-missing'),
                10000,
                ColorClass.Danger
            );
            this.isControlSaveBlocked = false;
            return;
        }

        this._supplierWorktimeControlService
            .AddComletedStartControl(this.comletedStartControl)
            .subscribe((worktimeStartControls) => {
                this.resetAll();
                this.isControlSaveBlocked = false;

                if (
                    worktimeStartControls &&
                    worktimeStartControls.body &&
                    worktimeStartControls.body.length > 0
                ) {
                    this.notCompletedStartControl = worktimeStartControls.body[0];
                    this.modalService.setModalVisibility(true, 'start-worktime-control');
                } else {
                    this.resetAll();
                    this.myTasksService.getMyTasks();
                    this.modalService.setModalVisibility(false, 'start-worktime-control');
                    this.modalService.setModalVisibility(true, 'start-worktime-confirm');
                }
            });
    }

    public onPhotoInputChanged(fileInput: any) {
        if (fileInput.target.files && fileInput.target.files[0]) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this._imageCompressionService
                    .compressImage(e.target.result, false, 85)
                    .then((result) => (this.imgResultAfterCompression = result));

                this.photoLoaded = true;
            };

            reader.onloadend = (e) => {
                const imageExtension = fileInput.target.files[0].name
                    .split('.')
                    .pop()
                    .toLowerCase();
                this.setControlPhotoImageContent(
                    reader.result.toString(),
                    imageExtension
                );
            };

            reader.readAsDataURL(fileInput.target.files[0]);
        }
    }

    public setControlPhotoImageContent(
        imageContent: string,
        imageExtension: string
    ): void {
        this.controlPhotoImageContent = imageContent;
        this.controlPhotoImageExtension = imageExtension;
        this.photoLoaded = true;
    }

    public resetAll() {
        this.additionalInfo = '';
        this.deletePhoto();
    }

    public deletePhoto(): void {
        this.controlPhotoImageContent = '';
        this.controlPhotoImageExtension = '';
        this.photoLoaded = false;
        this.imgResultAfterCompression = null;
    }

    handleTakeAPhoto() {
        this._iosAndAndroidNatvieFunctionsService.takeAPicture();
    }

    public IsControlsInvalid(): boolean {
        if (this.isAdditionalInfoInvalid || this.isPhotoInvalid) {
            return true;
        }
        return false;
    }

    public get isPhotoInvalid() {
        return (
            this.notCompletedStartControl.isPhotoRequired &&
            (this.imgResultAfterCompression == '' || !this.imgResultAfterCompression)
        );
    }

    startMultipicking() {
        this.myTasksService.startMultipicking();
    }

    public get isAdditionalInfoInvalid() {
        return (
            this.notCompletedStartControl.isAdditionalInfoRequired &&
            (this.additionalInfo == '' || !this.additionalInfo)
        );
    }
}
